import { render, staticRenderFns } from "./CheckboxType.vue?vue&type=template&id=79093a84"
import script from "./CheckboxType.vue?vue&type=script&lang=ts"
export * from "./CheckboxType.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxType.vue?vue&type=style&index=0&id=79093a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports